import { ReactNode } from "react";
import DBObject from "./DBObject";
import * as __d3ett from "../rocket/D3ETemplateTypes";
import Result from "../classes/Result";
import { AdminChangePassWordPageProps } from "../components/AdminChangePassWordPage";
import { SettingTabProps } from "../components/SettingTab";
import { HospitalTabProps } from "../components/HospitalTab";
import { SearchRequestResponseViewProps } from "../components/SearchRequestResponseView";
import { SystemAdminInvoiceListProps } from "../components/SystemAdminInvoiceList";
import { BillingDetailsViewProps } from "../components/BillingDetailsView";
import { ForgotPasswordPageProps } from "../components/ForgotPasswordPage";
import { HomePageProps } from "../components/HomePage";
import { DashboardPageProps } from "../components/DashboardPage";
import { LoginScreenProps } from "../components/LoginScreen";
import { StaffRequestTabProps } from "../components/StaffRequestTab";
import { StaffPageProps } from "../components/StaffPage";
import { SystemAdminRequestListProps } from "../components/SystemAdminRequestList";
import { SupportUserListProps } from "../components/SupportUserList";

export default class GlobalFunctions {
  public static save: (obj: DBObject) => Promise<Result<any>>;
  public static delete: (obj: DBObject) => Promise<Result<any>>;
  public static objectSave: (obj: DBObject, create: boolean) => void;
  public static fieldChanged: (
    obj: DBObject,
    field: number,
    oldValue: any
  ) => void;
  public static objectDelete: (obj: DBObject) => void;
  public static typeInt: (obj: string) => number;
  public static types: Array<__d3ett.D3ETemplateType>;
  public static AdminChangePassWordPage: (
    props: AdminChangePassWordPageProps
  ) => ReactNode;
  public static BillingDetailsView: (
    props: BillingDetailsViewProps
  ) => ReactNode;
  public static DashboardPage: (props: DashboardPageProps) => ReactNode;
  public static ForgotPasswordPage: (
    props: ForgotPasswordPageProps
  ) => ReactNode;
  public static HomePage: (props: HomePageProps) => ReactNode;
  public static HospitalTab: (props: HospitalTabProps) => ReactNode;
  public static LoginScreen: (props: LoginScreenProps) => ReactNode;
  public static SearchRequestResponseView: (
    props: SearchRequestResponseViewProps
  ) => ReactNode;
  public static SettingTab: (props: SettingTabProps) => ReactNode;
  public static StaffPage: (props: StaffPageProps) => ReactNode;
  public static StaffRequestTab: (props: StaffRequestTabProps) => ReactNode;
  public static SupportUserList: (props: SupportUserListProps) => ReactNode;
  public static SystemAdminInvoiceList: (
    props: SystemAdminInvoiceListProps
  ) => ReactNode;
  public static SystemAdminRequestList: (
    props: SystemAdminRequestListProps
  ) => ReactNode;
}
